<template>
  <div>
    <GeneralLink
      v-if="sectionHeading"
      _type="generalLink"
      :link="sectionHeading.link || []"
      text=""
      :class="{
        'group mb-5 border-b border-www-color-neutral-very-light pb-10px text-8px font-bold uppercase tracking-wider md:text-10px': true,
        'text-www-color-white md:text-www-color-neutral-medium-dark': true,
        'flex w-full items-center justify-between transition duration-300': true,
        'hover:border-www-color-primary-lighter hover:text-www-color-primary-lighter':
          sectionHeading.link,
        '[&_a]:block [&_a]:w-full [&_span:first-of-type]:flex [&_span:first-of-type]:w-full [&_span:first-of-type]:items-center [&_span:first-of-type]:gap-3': true,
      }"
    >
      <span>{{ sectionHeading.text }}</span>
      <PtcIcon
        v-if="sectionHeading.link?.[0]"
        :class="{
          'd-block group-hover:translate-x-1': true,
        }"
        name="ptc-arrow-white"
      ></PtcIcon>
    </GeneralLink>
    <ul
      :class="{
        'pb-2': true,
      }"
      aria-labelledby="subNavItem-Start"
    >
      <li
        v-for="(link, subMenuIndex) in sectionItems"
        :key="subMenuIndex"
        :class="{
          'transition duration-300 hover:text-www-color-primary-lighter': true,
        }"
      >
        <GeneralLink
          _type="generalLink"
          :link="link.link"
          text=""
          :class="{
            'text-www-color-white hover:text-www-color-primary-lighter md:text-www-color-neutral-medium-dark': true,
          }"
        >
          <h3
            :class="{
              'mb-5px text-13px font-bold uppercase tracking-wider': true,
            }"
          >
            {{ link.linkTitle }}
          </h3>
        </GeneralLink>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import type { ProductDropdown } from '~/sanity/types';
import GeneralLink from './GeneralLink.vue';
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';

defineProps<ProductDropdown['modernCad']>();
</script>

<style lang="scss" scoped></style>
